var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 180",
    preserveAspectRatio: "none",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2834",
    d: "M0 90C60 40 120 20 210 55C300 90 360 70 420 45V180H0V90Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#44A08D",
    opacity: 0.55,
    d: "M0 120C80 85 150 75 240 95C330 115 380 100 420 85V180H0V120Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F6F63",
    opacity: 0.35,
    d: "M0 145C90 125 170 130 250 145C330 160 380 150 420 140V180H0V145Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 96,
    rx: 3.5,
    ry: 5,
    fill: "white",
    opacity: 0.45
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 79,
    rx: 2.5,
    ry: 4,
    fill: "white",
    opacity: 0.35
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155,
    cy: 106,
    rx: 4,
    ry: 6,
    fill: "white",
    opacity: 0.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 83,
    rx: 2,
    ry: 3.5,
    fill: "white",
    opacity: 0.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225,
    cy: 99,
    rx: 3,
    ry: 5,
    fill: "white",
    opacity: 0.35
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260,
    cy: 73,
    rx: 2.5,
    ry: 4,
    fill: "white",
    opacity: 0.45
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295,
    cy: 93,
    rx: 3.5,
    ry: 5.5,
    fill: "white",
    opacity: 0.3
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 330,
    cy: 69,
    rx: 2.5,
    ry: 4,
    fill: "white",
    opacity: 0.4
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 365,
    cy: 89,
    rx: 2.5,
    ry: 4,
    fill: "white",
    opacity: 0.35
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105,
    cy: 108,
    rx: 2,
    ry: 3,
    fill: "white",
    opacity: 0.28
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 68,
    rx: 2,
    ry: 3,
    fill: "white",
    opacity: 0.32
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245,
    cy: 72,
    rx: 2.5,
    ry: 3.5,
    fill: "white",
    opacity: 0.3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315,
    cy: 82,
    rx: 2,
    ry: 3,
    fill: "white",
    opacity: 0.34
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 72,
    rx: 2.5,
    ry: 4,
    fill: "white",
    opacity: 0.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcWave);
export default __webpack_public_path__ + "static/media/cc-wave.12f0ad4f0dc6c49b3e70e1e81e650dc3.svg";
export { ForwardRef as ReactComponent };